import { EnlargedSearchResultContentSkeleton, EnlargedSearchResultSection, ResultContainer, ResultContainerOuter, SearchDialogContent } from '@atlassian/search-dialog';
import React, { useCallback } from 'react';
import { ProductStates } from '../../product-state-machine/product-state-machine-types';
import { useIsMobileView } from '../../utils/use-is-mobile-view';
import { GenericSearchResult } from '../../search-result/search-result';
import { SearchFooter, FilterFooter, FeedbackFooter } from '../quick-find-footer';
import { PreQueryEmptyScreen } from '../quick-find-screens';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../messages';
import { SearchErrorScreen } from '../../search-error-screen/search-error-screen';
import { SearchFooterPersistRecentSearch } from '../quick-find-footer/search-footer';
import { useProductContext } from '../../product-router';
import { QuickFindRovoTip } from '../quick-find-rovo-tip/quick-find-rovo-tip';
import { useRovoContext } from '../../../common/rovo-context/rovo-context';
import { ProductKeys } from '../../quick-find';
import { NoSearchResults } from '../../no-results-screen';
import { useSearchSessionId } from '../../../common/search-session-provider';
import { addQuery } from '../../../utils/url-utils';
export var QuickFindResultRenderer = function QuickFindResultRenderer(_ref) {
  var productState = _ref.productState,
    preQueryItems = _ref.preQueryItems,
    postQueryItems = _ref.postQueryItems,
    linkComponent = _ref.linkComponent,
    appendQueryParams = _ref.appendQueryParams,
    onRetryPreQuery = _ref.onRetryPreQuery,
    onRetryPostQuery = _ref.onRetryPostQuery;
  var isMobileView = useIsMobileView();
  var _useRovoContext = useRovoContext(),
    isRovoEnabled = _useRovoContext.isRovoEnabled;
  var searchSessionId = useSearchSessionId();
  var _useProductContext = useProductContext(),
    getActiveProduct = _useProductContext.getActiveProduct;
  var activeProduct = getActiveProduct();
  var productId = activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.id;
  var renderResults = useCallback(function () {
    switch (productState) {
      case ProductStates.PreQuerySuccess:
      case ProductStates.PreQueryLoading:
        return /*#__PURE__*/React.createElement(GenericSearchResult, {
          searchItems: preQueryItems,
          linkComponent: linkComponent,
          screen: "preQuerySearchResults",
          productState: productState,
          isCollapsed: isMobileView,
          appendQueryParams: appendQueryParams
        });
      case ProductStates.PreQueryNoResult:
        return /*#__PURE__*/React.createElement(PreQueryEmptyScreen, null);
      case ProductStates.PreQueryError:
        return /*#__PURE__*/React.createElement(SearchErrorScreen, {
          onRetry: onRetryPreQuery
        });
      case ProductStates.PostQueryTyping:
      case ProductStates.PostQueryLoading:
        return /*#__PURE__*/React.createElement(GenericSearchResult, {
          searchItems: postQueryItems,
          linkComponent: linkComponent,
          screen: "cachedResults",
          productState: productState,
          isCollapsed: isMobileView,
          appendQueryParams: appendQueryParams
        }, /*#__PURE__*/React.createElement(EnlargedSearchResultSection, {
          title: /*#__PURE__*/React.createElement(FormattedMessage, messages.quick_find_search_results)
        }, /*#__PURE__*/React.createElement(EnlargedSearchResultContentSkeleton, null), /*#__PURE__*/React.createElement(EnlargedSearchResultContentSkeleton, null), /*#__PURE__*/React.createElement(EnlargedSearchResultContentSkeleton, null), /*#__PURE__*/React.createElement(EnlargedSearchResultContentSkeleton, null), /*#__PURE__*/React.createElement(EnlargedSearchResultContentSkeleton, null)));
      case ProductStates.PostQueryError:
        return /*#__PURE__*/React.createElement(SearchErrorScreen, {
          onRetry: onRetryPostQuery
        });
      case ProductStates.PostQueryNoResult:
        var urlGeneratorForNoResultsScreen = function urlGeneratorForNoResultsScreen(query) {
          var generateUrl = (activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.generateAdvancedSearchUrl) || function () {
            return '';
          };
          var advancedSearchUrl = generateUrl(query);
          return addQuery(advancedSearchUrl, 'search_id', searchSessionId);
        };
        return /*#__PURE__*/React.createElement(NoSearchResults, {
          urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
          fromQuickFindPostQueryNoResults: true
        });
      case ProductStates.PostQuerySuccess:
        return /*#__PURE__*/React.createElement(GenericSearchResult, {
          searchItems: postQueryItems,
          linkComponent: linkComponent,
          screen: "postQuerySearchResults",
          productState: productState,
          isCollapsed: isMobileView,
          appendQueryParams: appendQueryParams
        });
    }
  }, [productState, preQueryItems, linkComponent, isMobileView, appendQueryParams, postQueryItems, onRetryPreQuery, onRetryPostQuery, activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.generateAdvancedSearchUrl, searchSessionId]);
  var showSearchFooter = productState === ProductStates.PreQuerySuccess || productState === ProductStates.PreQueryLoading || productState === ProductStates.PreQueryNoResult || productId === ProductKeys.Confluence && (productState === ProductStates.PostQuerySuccess || productState === ProductStates.PostQueryLoading || productState === ProductStates.PostQueryNoResult);
  var showFilterFooter = productId === ProductKeys.Confluence && (productState === ProductStates.PostQuerySuccess || productState === ProductStates.PostQueryLoading || productState === ProductStates.PostQueryNoResult);
  var showFeedbackFooter = productState === ProductStates.PreQuerySuccess || productState === ProductStates.PostQuerySuccess || productState === ProductStates.PostQueryLoading || productState === ProductStates.PostQueryNoResult;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isRovoEnabled && /*#__PURE__*/React.createElement(QuickFindRovoTip, null), /*#__PURE__*/React.createElement(SearchDialogContent, null, /*#__PURE__*/React.createElement(ResultContainerOuter, null, /*#__PURE__*/React.createElement(ResultContainer, {
    "aria-live": "polite"
  }, renderResults()))), showSearchFooter && productId === ProductKeys.Confluence ? /*#__PURE__*/React.createElement(SearchFooterPersistRecentSearch, {
    linkComponent: linkComponent
  }) : /*#__PURE__*/React.createElement(SearchFooter, {
    linkComponent: linkComponent
  }), showFilterFooter && /*#__PURE__*/React.createElement(FilterFooter, null), showFeedbackFooter && /*#__PURE__*/React.createElement(FeedbackFooter, null));
};